import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

// Bridges a notification toast (root-level) to whichever TasksForMeComponent
// instance is currently mounted, since TasksStore is component-scoped and
// the toast has no direct reference to it.
@Injectable({ providedIn: 'root' })
export class TaskListRefreshService {
  private readonly _refresh$ = new Subject<void>();
  readonly refresh$ = this._refresh$.asObservable();

  // Set by a successful write; the list reloads once when a page opened over it closes.
  private stale = false;

  requestRefresh(): void {
    this._refresh$.next();
  }

  markStale(): void {
    this.stale = true;
  }

  // The list has just loaded its data, so earlier writes are already reflected.
  clearStale(): void {
    this.stale = false;
  }

  consumeStale(): boolean {
    const wasStale = this.stale;
    this.stale = false;
    return wasStale;
  }
}
